import { AuthFrame } from '../components/auth-frame';
import { MagicLinkRequestCard } from '../components/magic-link-request-card';

export function MagicLinkRequestPage() {
  return (
    <AuthFrame>
      <MagicLinkRequestCard />
    </AuthFrame>
  );
}
